var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250.94 277.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0895df;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,118c1.95,22,.16,44.94.16,66.8v92.48H246.9l-4.56-.92c-16.4-3.25-29.89-11.54-41.05-23.79-8.45-9.28-12.44-20.07-12.31-32.84.2-18.71.21-37.43.16-56.15-.07-23.39,3.44-49-8.72-70.23a63.85,63.85,0,0,0-67.58-30.72c-29.66,5.76-51.55,32.09-51.39,62.24.1,19.7,7.71,36.23,22.72,49,13.29,11.31,28.93,16.06,46.33,14.84,11.43-.79,21.65-5,31.12-11.26,1.35-.89,2.72-1.76,4.25-2.75,0,.56.09.85.09,1.14q0,33,0,66.09c0,1.2-.53,1.55-1.5,1.86-21.41,6.86-43.13,8.53-65.16,3.66-27.89-6.17-51.38-20-69.7-41.94C6.15,177.35-3.83,144.94,1.32,108.45c4-28.24,16.11-52.69,36.58-72.68C60.62,13.57,88.09,1.84,119.73.18A116.68,116.68,0,0,1,182.19,14c35.33,19,59.31,50.86,66.13,90.58C249.07,109,249.63,113.49,250,118Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ff446456b0afe94e366884f7734d8285.svg";
export { ForwardRef as ReactComponent };